var render = function render(){var _vm=this,_c=_vm._self._c;return _c('j-banner-container',{attrs:{"header":"Stats","backLink":`/p/${_vm.userId}`,"md":"6","gradient":['red-background', 'yellow-background'],"slot-text-align":"left"}},[_c('activity-overview',{attrs:{"userId":_vm.decodedId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }